<div class="toast-stack" role="region" aria-live="polite" aria-label="Notifications">
  @for (item of notifications(); track item) {
    <div class="toast" [class]="classFor(item)" role="status">
      <mat-icon class="toast__icon">{{ iconFor(item) }}</mat-icon>
      <span class="toast__message">{{ item.message }}</span>
      <button
        type="button"
        class="toast__close"
        aria-label="Dismiss"
        (click)="dismiss(item)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
